module.exports = "<div class=\"modal-header\">\n  <h4 class=\"modal-title\">Add New Project</h4>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"close(false)\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p>Choose a Project: </p>\n    <ng-content></ng-content>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-primary\" (click)=\"close(true)\">Add</button>\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close(false)\">Cancel</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/addprojectmodal.component.html
// module id = 610
// module chunks = 1